import { render, staticRenderFns } from "./sysMsgConfig.vue?vue&type=template&id=60381a8e&scoped=true&"
import script from "./sysMsgConfig.vue?vue&type=script&lang=js&"
export * from "./sysMsgConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60381a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60381a8e')) {
      api.createRecord('60381a8e', component.options)
    } else {
      api.reload('60381a8e', component.options)
    }
    module.hot.accept("./sysMsgConfig.vue?vue&type=template&id=60381a8e&scoped=true&", function () {
      api.rerender('60381a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/sysMsgConfig.vue"
export default component.exports